import React from 'react'
import {useContext} from 'react'

import Title from './Title'
import { RoomContext } from '../context'

// get all unique value
const getUnique = (rooms,value)=>{
    return [...new Set(rooms.map(room => room[value]))]
}

export default function RoomFilter({rooms}) {
    const context = useContext(RoomContext)

    const {
        handleChange,
        type,
        capacity,
        price,
        minPrice,
        maxPrice,
        minSize,
        maxSize,
        breakfast,
        pets
    }  = context

    // console.log(context)
    // get unique type
    let types = getUnique(rooms,'type')

    // get all type
    types = ['all',...types]

    //map to jsx
    types = types.map((type,index)=>{
        return <option key={index} value={type} > {type} </option>
    })

    let people = getUnique(rooms,'capacity')
    people = people.map((item,index)=>{
    return <option key={index} value={item}> {item} </option>
    })

    return (
        <section className="filter-container">
            <Title title="search room" />
            <form className="filter-form">
                {/* select type */}
                <div className="form-group">
                    <label htmlFor="type">Room Type</label>
                    <select name="type" id="type" className="form-control" value={type}  onChange={handleChange}>
                        {types}
                    </select>
                </div>
                {/* end select */}
                {/* guest  */}
                <div className="form-group">
                    <label htmlFor="capacity">Guest</label>
                    <select name="capacity" id="capacity" className="form-control" value={capacity}  onChange={handleChange}>
                        {people}
                    </select>
                </div>
                {/* end guest */}

                {/* room price */}
                <div className="form-group">
                    <label htmlFor="price">room price ${price}</label>
                    <input type="range" name="price" min={minPrice} max={maxPrice} className="form-control" id="price" value={price} onChange={handleChange} />
                </div>
                {/* end room price */}

                {/* size */}
                <div className="form-group">
                    <label htmlFor="size">Size room</label>
                    <div className="size-inputs">
                        <input type="number" id="size" name="minSize" value={ minSize }  className="size-input"  onChange={handleChange}  />
                        <input type="number" id="size" name="maxSize" value={ maxSize }  className="size-input"  onChange={handleChange}  />
                    </div>
                </div>
                {/* end of size */}

                {/* extras */}
                <div className="form-group">
                    <div className="single-extra">
                        <input type="checkbox" name="breakfast" id="breakfast" checked={breakfast}  onChange={ handleChange}/>
                        <label htmlFor="breakfast">breakfast</label>
                    </div>

                    <div className="single-extra">
                        <input type="checkbox" name="pets" id="pets" checked={pets}  onChange={ handleChange}/>
                        <label htmlFor="pets">pets</label>
                    </div>
                </div>
                {/* end extras */}
            </form>
        </section>
    )
}
